import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {

  @Input()
  headerTitle: string = "";
  
  @Input()
  backgroundImgColor: string = "green";

  constructor() { }

  ngOnInit(): void {
  }

}
